import { render, staticRenderFns } from "./BuildingSwitcher.vue?vue&type=template&id=654858a8&scoped=true&"
import script from "./BuildingSwitcher.vue?vue&type=script&lang=js&"
export * from "./BuildingSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654858a8",
  null
  
)

export default component.exports